import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from "@angular/core";

@Component({
  selector: "lba-sensor-status-by-minute-chart",
  templateUrl: "./sensor-status-by-minute-chart.html",
  styleUrls: ["./sensor-status-by-minute-chart.scss"],
})
export class SensorStatusByMinuteChart implements OnChanges {

  @Input() sensorWorkCapacity;
  @Input() hourDisplay: string;
  @Input() date: string;

  tooltips: string[] = new Array(60).fill('...');

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sensorWorkCapacity.firstChange && changes.sensorWorkCapacity.currentValue.length === 60) {
      this.tooltips = this.sensorWorkCapacity.map((item, index) => `${this.hourDisplay}:` + `0${index}`.slice(-2));
    }
  }
}
